export default "__VITE_ASSET__CZt5$WvW__"